const { io } = require("socket.io-client");

let connection = { 'on': function () { }, 'emit': function () { } };
try {
	connection = io(`${location.protocol}//${location.hostname}:4010/`);
} catch (error) {
	console.error(error);
}

module.exports = {
	connection
}
